module.exports = __webpack_public_path__ + "static/media/jewelry3.f01ed251.jpg";